import React from 'react';
import { useNavigate } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { 
    FaClipboardList, 
    FaCheckCircle,
    FaArrowLeft,
    FaArrowRight
} from 'react-icons/fa';

const EngineerWorkInfo = () => {
    const navigate = useNavigate();

    const ActionCard = ({ title, subtitle, icon, onClick, colorClass, iconColor }) => (
        <div 
            onClick={onClick}
            className="group cursor-pointer bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col items-start overflow-hidden h-full"
        >
            <div className={`h-1.5 w-full ${colorClass}`}></div>
            <div className="p-8 flex flex-col items-start space-y-6 flex-grow">
                <div className={`p-4 rounded-xl ${iconColor} bg-opacity-10 transition-transform duration-500 group-hover:scale-110 shadow-sm`}>
                    <div className={`text-3xl ${iconColor.replace('bg-', 'text-')}`}>
                        {icon}
                    </div>
                </div>
                <div>
                    <h3 className="text-xl font-bold text-gray-800 tracking-tight mb-2">
                        {title}
                    </h3>
                    <p className="text-gray-400 text-sm font-bold">
                        {subtitle}
                    </p>
                </div>
            </div>
            <div className="w-full h-12 px-8 flex items-center justify-between border-t border-gray-50 bg-gray-50/30 group-hover:bg-gray-50 transition-colors">
                <span className="text-gray-400 text-xs font-bold uppercase tracking-widest">निवडा</span>
                <FaArrowRight className="text-gray-300 group-hover:text-gray-600 transition-colors" size={14} />
            </div>
        </div>
    );

    return (
        <EngineerLayout>
            <div className="p-6 md:p-8 bg-gray-50/30 min-h-screen">
                {/* Dark Header Card */}
                <div className="bg-[#1a1c23] rounded-3xl p-10 mb-12 shadow-2xl relative overflow-hidden group">
                    <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-32 -mt-32 blur-3xl transition-transform duration-1000 group-hover:scale-110"></div>
                    <div className="absolute bottom-0 left-0 w-32 h-32 bg-[#085e53]/10 rounded-full -ml-16 -mb-16 blur-2xl"></div>
                    
                    <div className="relative flex flex-col md:flex-row justify-between items-center gap-6">
                        <div className="flex items-center gap-6">
                            <button 
                                onClick={() => navigate('/engineer/all-users')}
                                className="bg-white/10 hover:bg-white/20 text-white p-4 rounded-2xl transition-all hover:scale-110 active:scale-90 backdrop-blur-sm border border-white/10"
                            >
                                <FaArrowLeft size={18} />
                            </button>
                            <div>
                                <h1 className="text-4xl font-bold text-white tracking-tight mb-3">कामाची माहिती (Work Information)</h1>
                                <p className="text-gray-400 font-bold text-sm tracking-widest uppercase">
                                    कामाचा प्रकार निवडण्यासाठी खालील पर्यायांवर क्लिक करा
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Cards Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-10 max-w-4xl mx-auto">
                    <ActionCard 
                        title="कामाची माहिती (Work Names)" 
                        subtitle="कामाची नावे आणि तपशील व्यवस्थापित करा"
                        icon={<FaClipboardList />} 
                        onClick={() => navigate('/engineer/work-names-list')}
                        colorClass="bg-[#3b82f6]"
                        iconColor="bg-[#3b82f6]"
                    />
                    <ActionCard 
                        title="वर्क ट्रान्सफर यादी(Approved Works)" 
                        subtitle="मंजूर कामांचे अहवाल आणि माहिती"
                        icon={<FaCheckCircle />} 
                        onClick={() => navigate('/engineer/work-reports-menu')}
                        colorClass="bg-[#10b981]"
                        iconColor="bg-[#10b981]"
                    />
                </div>
            </div>
        </EngineerLayout>
    );
};

export default EngineerWorkInfo;
